export default "__VITE_ASSET__0cd5c92e__"